import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup, Validators, FormBuilder, FormControl } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as _ from 'lodash';
import { NavigationService } from 'src/app/services/navigation.service';
import { ProductService } from 'src/app/services/product.service';
@Component({
  selector: 'app-addproductpopup',
  templateUrl: './addproductpopup.component.html',
  styleUrls: ['./addproductpopup.component.scss']
})
export class AddProductPopupComponent implements OnInit {

  form: FormGroup;
  serviceArray: any = [];
  value: any;
  submitBtn = true;
  submitBtnTxt = "Save";
  classificationList: any[];
  showNotes: boolean = true;
  category: boolean;
  primemover: boolean;
  nonprimemover: boolean;
  classificationListCopy: any[];
  categoryTypeList: any[];
  categoryTypeListCopy: any[];
  powerSourceList: any[];
  powerSourceListCopy: any[];
  implementList: any[];
  implementListCopy: any[];
  nonprimemoverList: any[];
  nonprimemoverListCopy: any[];
  sampleList: any[] = [];
  newddList: any[] = [];
  samplelst: any[] = [];
  constructor(public dialogRef: MatDialogRef<AddProductPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public dataRecievedToEdit: any,
    private formBuilder: FormBuilder,
    private productService: ProductService,
    private navigationService: NavigationService,
    public addServiceDialog: MatDialog) {
  }

  ngOnInit() {
    this.initializeValidators();
    this.getClassificationList(true);
    this.showNotes = true;
  }

  initializeValidators() {
    this.form = this.formBuilder.group({
      classification: ['', Validators.required],
      categoryType: [''],
      farmingType: [''],
      powerSource: [''],
      productName: ['', Validators.required],
      dropdownvalue1: ['']
      // nonprimemover: ['',Validators.required],
    });
  }

  getDropdownList() {
    this.form.controls['powerSource'].setValue(null);
    if (this.form.value.classification == 1) {
      this.primemover = true;
      this.category = true;
      this.form.controls['powerSource'].clearValidators();
      this.form.controls['powerSource'].updateValueAndValidity();
      var data = {
        machinaryClassificationId: this.form.value.classification,
        machinaryCategoryId: this.form.value.categoryType,
        powerSourceId: (this.form.value.powerSource > 0 ? this.form.value.powerSource : 0),
      }

      this.sampleList = [];
      this.newddList = [];
      this.productService.getProductDropDownLookUp(data, true).subscribe(result => {
        if (result) {
          this.samplelst = result;
          if (this.samplelst.length > 0) {
            this.sampleList = [];
            this.sampleList.push(this.samplelst[0]);
          } else {
            this.getProductType();
          }
        }
      });
    } else if (this.form.value.classification == 2) {
      this.primemover = false;
      this.category = false;
      this.form.controls['powerSource'].setValidators(Validators.required);
      this.form.controls['powerSource'].updateValueAndValidity();
      this.getpowerSource();
    } else if (this.form.value.classification == 3) {
      this.primemover = false;
      this.category = false;
      // this.form.controls['powerSource'].setValidators(Validators.required);
      // this.form.controls['powerSource'].updateValueAndValidity();
      this.getpowerSource();
      this.getProductType();
    } else {
      this.category = false;
      this.primemover = true;
      this.form.controls['powerSource'].clearValidators();
      this.form.controls['powerSource'].updateValueAndValidity();
      this.getProductType();
      var data = {
        machinaryClassificationId: this.form.value.classification,
        machinaryCategoryId: this.form.value.categoryType,
        powerSourceId: (this.form.value.powerSource > 0 ? this.form.value.powerSource : 0),
      }

      this.sampleList = [];
      this.newddList = [];
      this.productService.getProductDropDownLookUp(data, true).subscribe(result => {
        if (result) {
          this.samplelst = result;
          if (this.samplelst.length > 0) {
            this.sampleList = [];
            this.sampleList.push(this.samplelst[0]);
          }
        }
      });
    }

  }

  getClassificationList(refresh: any) {
    this.classificationList = [];
    this.classificationListCopy = [];
    this.productService.getMachinaryClassificationLookUp(refresh).subscribe(result => {
      if (result) {
        this.classificationList = result;
        this.classificationListCopy = this.classificationList;
        this.classificationListCopy = this.classificationListCopy.slice();
      }
    });
  }

  getCategoryType(event: any) {
    this.categoryTypeList = [];
    this.categoryTypeListCopy = [];
    this.productService.getMachinaryCategoryLookUp(event, true).subscribe(result => {
      if (result) {
        this.categoryTypeList = result;
        this.categoryTypeListCopy = this.categoryTypeList;
        this.categoryTypeListCopy = this.categoryTypeListCopy.slice();
        this.categoryTypeListCopy = _.orderBy(this.categoryTypeListCopy, ['value'], ['asc']);
      }
    });
  }

  dropdownChange(event: any, dbtProductSpecId: number) {
    this.newddList = [];
    var item = {
      "dbtProductSpecId": dbtProductSpecId,
      "id": event.value
    }
    this.newddList.push(item);
    this.getProductType();
  }

  getdriveType() {
    this.form.controls['powerSource'].setValue(null);
    if (this.form.value.classification == 1) {
      this.primemover = true;
      this.category = true;
      this.form.controls['powerSource'].clearValidators();
      this.form.controls['powerSource'].updateValueAndValidity();
    } else if (this.form.value.classification == 2) {
      this.primemover = false;
      this.category = false;
      this.form.controls['powerSource'].setValidators(Validators.required);
      this.form.controls['powerSource'].updateValueAndValidity();
      this.getpowerSource();
    } else if (this.form.value.classification == 3) {
      this.primemover = false;
      this.category = false;
      // this.form.controls['powerSource'].setValidators(Validators.required);
      // this.form.controls['powerSource'].updateValueAndValidity();
      this.getpowerSource();
      this.getProductType();
    } else {
      this.category = false;
      this.primemover = true;
      this.form.controls['powerSource'].clearValidators();
      this.form.controls['powerSource'].updateValueAndValidity();
      this.getProductType();
    }
  }

  getpowerSource() {
    this.powerSourceList = [];
    this.powerSourceListCopy = [];
    this.productService.getPowerSourcenLookUp(true).subscribe(result => {
      if (result) {
        this.powerSourceList = result;
        this.powerSourceListCopy = this.powerSourceList;
        this.powerSourceListCopy = this.powerSourceListCopy.slice();
        this.powerSourceListCopy = _.orderBy(this.powerSourceListCopy, ['value'], ['asc']);

      }
    });
  }

  powersourcechange() {
    var data = {
      machinaryClassificationId: this.form.value.classification,
      machinaryCategoryId: this.form.value.categoryType,
      powerSourceId: (this.form.value.powerSource > 0 ? this.form.value.powerSource : 0),
    }

    this.sampleList = [];
    this.newddList = [];
    this.productService.getProductDropDownLookUp(data, true).subscribe(result => {
      if (result) {
        this.samplelst = result;
        if (this.samplelst.length > 0) {
          this.sampleList = [];
          this.sampleList.push(this.samplelst[0]);
        } else {
          this.getProductType();
        }
      }
    });
  }

  getProductType() {
    this.implementList = [];
    this.implementListCopy = [];
    var data = {
      machinaryClassificationId: this.form.value.classification,
      machinaryCategoryId: this.form.value.categoryType,
      powerSourceId: (this.form.value.powerSource > 0 ? this.form.value.powerSource : 0),
      specList: this.newddList
    }
    this.productService.getProductLookUp(data).subscribe(result => {
      if (result) {
        this.implementList = _.orderBy(result, ['value'], ['asc']);
        this.implementListCopy = this.implementList;
        this.implementListCopy = this.implementListCopy.slice();
      }
    });

  }

  onChange(event: any) {
    this.getCategoryType(event.value);
    var selected = this.form.value.classification;
    this.value = selected;
    this.category = false;
    this.sampleList = [];
    this.newddList = [];
    this.form.controls['powerSource'].setValue(null);
    this.form.controls['categoryType'].setValue(null);
    if (this.value == 1) {
      this.primemover = true;
      //   this.form.controls['powerSource'].clearValidators();
      //   this.form.controls['powerSource'].updateValueAndValidity();
    }
    // else if(this.value == 1 && event.value != 1){
    //   this.primemover = true;
    //   this.form.controls['powerSource'].clearValidators();
    //   this.form.controls['powerSource'].updateValueAndValidity();
    // }
    else {
      this.primemover = false;
      //   this.categoryTypeListCopy = [];
      //   this.form.controls['powerSource'].setValidators(Validators.required);
      //   this.form.controls['powerSource'].updateValueAndValidity();

    }
  }

  onSubmit(event: any) {
    if (this.form.valid) {
      this.serviceArray.push(this.form.value);
      this.navigationService.gotoProductAdd(0, 0, event.value, this.form.value.classification, this.form.value.categoryType);
      this.dialogRef.close();
    } else {
      this.validateFormControl();
    }
  }
  next() {
    this.showNotes = false;
  }

  validateFormControl() {
    Object.keys(this.form.controls).forEach(field => {
      const control = this.form.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({
          onlySelf: true
        });
      }
    })
  }


  onCancel(isProceed) {
    this.dialogRef.close(isProceed);
  }

  close(isProceed) {
    this.dialogRef.close(isProceed);
  }


}
